/**
 * XNGAGE CONFIDENTIAL
 * __________________________
 *
 * Copyright (C) 2020 Xngage - All Rights Reserved
 *
 * All code or information contained herein is, and remains the
 * property of Xngage LLC and its customers.  The intellectual
 * and technical concepts contained are proprietary to Xngage LLC
 * and may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Xngage LLC.
 */
/* eslint-disable spire/fenced-imports */
import { addTask } from "@insite/client-framework/ServerSideRendering";
import { getBrands } from "@insite/client-framework/Services/BrandService";
import { AdminODataApiParameter } from "@insite/shell/Services/AdminService";
import ShellThunkAction from "@insite/shell/Store/ShellThunkAction";

export const loadSelectBrands = (parameter?: AdminODataApiParameter): ShellThunkAction => dispatch => {
    addTask(
        (async function () {
            const results = await getBrands({
                randomize: false,
                pageSize: 500,
                select: "id,detailPagePath,logoSmallImagePath,logoAltText,name",
            });

            const brands = results.brands?.map(brand => {
                return {
                    id: brand.id,
                    name: brand.name,
                    path: brand.detailPagePath,
                };
            });

            dispatch({
                brands: brands || [],
                type: "PageEditor/CompleteLoadSelectBrands",
            });
        })(),
    );
};

export const loadSelectedBrands = (parameter?: AdminODataApiParameter): ShellThunkAction => dispatch => {
    addTask(
        (async function () {
            const results = await getBrands({
                randomize: false,
                pageSize: 500,
                select: "id,detailPagePath,logoSmallImagePath,logoAltText,name",
            });

            const brands = results.brands?.map(brand => {
                return {
                    id: brand.id,
                    name: brand.name,
                    path: brand.detailPagePath,
                };
            });

            dispatch({
                brands: brands || [],
                type: "PageEditor/CompleteLoadSelectedBrands",
            });
        })(),
    );
};
